<div class="modal-body login-register-popup">
  <div class="registration_div" *ngIf="!isLoginView">
    <app-register
      (onShowLogin)="switchView(true)"
      (registered)="closeDialog()"
      [location]="location"
      [pageCategory]="pageCategory"
      [prdImage]="prdImg"
      [isWishlistReg]="isWishlist"
    ></app-register>
  </div>
  <div class="login_div" *ngIf="isLoginView">
    <h3 class="main-label membersignin">{{ 'MEMBER SIGN IN' | translate }}</h3>
    <div class="form-group" *ngIf="prdImg">
      <img class="productImg" src="{{ prdImg }}" />
    </div>
    <app-login
      (loggedin)="closeDialog()"
      [prdImg]="prdImg"
      [location]="location"
      [isWishlist]="isWishlist"
      [pageCategory]="pageCategory"
    ></app-login>
    <h4 class="main-label notmember">{{ 'NOT A MEMBER YET?' | translate }}</h4>
    <button class="btn tvb-button primary" type="submit" (click)="openTypeformModal()">
      {{ 'CREATE AN ACCOUNT' | translate }}
    </button>
  </div>
</div>

<div id="typeformModal" class="modal" (click)="closeTypeformModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <span class="close" (click)="closeTypeformModal()">&times;</span>
    <iframe
      src="https://form.typeform.com/to/PzU95xDX"
      data-testid="iframe"
      allow="microphone; camera"
      title="Professional Sellers"
      style="border: 0px; width: 100%; height: 600px"
    ></iframe>
  </div>
</div>
